import { Stack, useTheme } from '@mui/system';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import strings from 'common/Translation/Translate';
import { FC } from 'react';
import { images } from 'utils/constants/images';

interface MiceEventsProps {
  miceEvents: Array<any>;
  eventTypes: Array<any>;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

const MiceEventsTable: FC<MiceEventsProps> = ({ miceEvents, eventTypes, onEdit, onDelete }: any) => {
  const theme = useTheme();

  const columns: GridColDef[] = [
    {
      field: 'eventType',
      headerName: strings.sales_management_branch_competitions_column_mice_event_type,
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'eventSubtype',
      headerName: 'Event Subtype',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'noOfPax',
      headerName: strings.sales_management_branch_competitions_mice_event_pax,
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'roomNights',
      headerName: strings.sales_management_branch_competitions_mice_event_room_nights,
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'potentialRevenue',
      headerName: strings.sales_management_branch_competitions_mice_event_potential_revenue,
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'Action',
      headerName: strings.customermgmt_column_action,
      sortable: false,
      flex: 1,
      minWidth: 100,
      align: 'right',
      headerAlign: 'right',
      renderCell: (ValueFormatterParams: any) => {
        return (
          <Stack direction="row" spacing={2}>
            <img
              src={images.editIcon}
              alt="edit"
              width="20px"
              height="20px"
              style={{ cursor: 'pointer' }}
              onClick={(e: any) => {
                e.stopPropagation();
                onEdit(ValueFormatterParams.row.id);
              }}
            />
            <img
              className={'cursor-pointer'}
              src={images.deleteIcon}
              alt="delete"
              width="20px"
              height="20px"
              style={{ cursor: 'pointer' }}
              onClick={(e: any) => {
                e.stopPropagation();
                onDelete(ValueFormatterParams.row.id);
              }}
            />
          </Stack>
        );
      },
    },
  ];

  return miceEvents?.length > 0 ? (
    <div style={{ width: '100%' }}>
      <div style={{ height: 300, width: '100%' }}>
        <DataGrid
          sx={{
            overflow: 'auto',
            '.MuiDataGrid-row': {
              cursor: 'pointer',
              ':hover': {
                backgroundColor: `${theme.palette.primary.main}09}`,
              },
            },
            '.MuiDataGrid-columnHeaders': {
              backgroundColor: `${theme.palette.primary.main}35}`,
            },
          }}
          rowHeight={60}
          rows={miceEvents.map((item: any, idx: any) => ({
            ...item,
            eventType: eventTypes.find((i: any) => i.value === item.eventType.value)?.label,
            id: idx,
          }))}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          disableColumnMenu
          disableSelectionOnClick
          autoHeight
          hideFooter
        />
      </div>
    </div>
  ) : null;
};

export default MiceEventsTable;
